import React, { useState } from 'react'
import { Manager, Reference, Popper } from 'react-popper'

import { useStyles } from './button.style'

export const Button = function ({ children, _ref, className = '', variant = '', size = '', iconClass = '', tooltipLabel = '', ...props }) {
  const classes = useStyles()
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)

  if ((variant === 'icon') || (variant === 'icon-secondary')) {
    let variantClass

    switch (variant) {
      case 'icon-secondary':
        variantClass = classes.iconSecondary
        break
      default:
        variantClass = classes.button
    }

    return (
      <Manager>
        <Reference>
          {({ ref }) => (
            <button type="button" ref={ref} className={`${variantClass} ${className}`}
              onMouseOver={() => { setIsTooltipOpen(tooltipLabel.length > 0) }}
              onMouseOut={() => { setIsTooltipOpen(false) }}
              {...props}
            >
              <div className={iconClass}></div>
            </button>
          )}
        </Reference>
        {isTooltipOpen &&
          <Popper placement="top">
            {({ ref, style, placement, arrowProps }) => (
              <div ref={ref} style={style} data-placement={placement} className="tooltip-content">
                {tooltipLabel}
                <div ref={arrowProps.ref} style={arrowProps.style} className="tooltip-tip" />
              </div>
            )}
          </Popper>
        }
      </Manager>
    )
  } else {
    let variantClass
    let sizeClass = ''

    switch (variant) {
      case 'link':
        variantClass = classes.link
        break
      case 'inline-link':
        variantClass = classes.inlineLink
        break
      case 'secondary':
        variantClass = classes.secondary
        break
      case 'mini':
        variantClass = classes.mini
        break
      case 'mini-secondary':
        variantClass = classes.miniSecondary
        break
      default:
        variantClass = classes.button
    }

    switch (size) {
      case 'large':
        sizeClass = classes.large
        break
    }

    return (
      <button className={`${variantClass} ${sizeClass} ${className}`} ref={_ref} {...props}>
        {children}
      </button>
    )
  }
}
